import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { UserService } from '../../shared/services/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { MustMatch } from '../../shared/validator/must-match.validator';
import { first } from 'rxjs/operators';
import { ResetPassword } from './forget-password.model';
import { PasswordStrengthValidator } from '../../shared/validator/password-strength.validators';
import { LookupService } from '../../shared/services/lookup.service';
import { Configuration } from '../../shared/models/configuration.model';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { Service } from 'src/app/shared/models/enums.model';
import { GlobalServices } from 'src/app/shared/services/global.service';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.css']
})
export class ForgetPasswordComponent implements OnInit {
  forgetPasswordForm: FormGroup;
  loading = false;
  submitted = false;
  responseObject: ResponseObject;
  userName: string = '';
  confirmationCode: string = '';
  //confirmationDate: Date = new Date();
  //confirmationDateString: string = '';
  //currentDate: Date = new Date();
  //currentDateString: string = '';
  resetPassword: ResetPassword = new ResetPassword();
  configurations: Configuration[] = [];
  oneConfig: Configuration = new Configuration();
  showRequest=false;
  configValue: number;
  constructor(private formBuilder: FormBuilder,
    private alertService: AlertService,
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private lookupSrv: LookupService,
    private datePipe: DatePipe,
    private translate: TranslateService,
    private global: GlobalServices ) {


    this.userName = this.route.snapshot.params.UserName;
    this.confirmationCode = this.route.snapshot.params.ConfirmationCode;
   // this.confirmationDate = this.route.snapshot.params.ConfirmationCreationDate;
    

    // this.userService.CheckCodeValid(this.userName, this.confirmationCode).pipe(first())
    //   .subscribe(
    //     (data: ResponseObject) => {

    //       if (!data.Success) {
    //         this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + this.responseObject.ErrorMessages[0]));
    //         this.router.navigate(['/resetpassword']);
    //       }

    //     });

    // this.lookupSrv.GetConfiguration().subscribe((data: ResponseObject) => {
    //   
    //   this.configurations = data.Data as Configuration[];
    //   this.configurations = this.configurations.filter(c => c.ServiceId == Service.ForgetPassword);
    //   let expiratipnValue = +this.configurations[0].Value;
    //   let currentdatenumber = new Date(this.confirmationDate).getDate();//1000 * 60 * 60 * 24;
    //   new Date(this.confirmationDate).setDate(currentdatenumber + expiratipnValue);
    //   if (new Date(this.confirmationDate) > new Date('2017-03-08T00:00:00')) {
    //     this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.LinkInValid'));
    //     this.router.navigate(['/resetpassword']);
    //   }


    // });

  }


  ngOnInit() {


    this.buildForm();

  }

  buildForm() {
    this.forgetPasswordForm = this.formBuilder.group({
      username: [''],
      newpassword: ['', [Validators.required,  PasswordStrengthValidator]],
      confirmpassword: ['', Validators.required]
    },
      { validator: MustMatch('newpassword', 'confirmpassword') }
    );

  }
  get f() {
    return this.forgetPasswordForm.controls;
  }

  onSubmit() {
    this.submitted = true;

    this.alertService.clear();
    // stop here if form is invalid
    if (this.forgetPasswordForm.invalid) {
      return;
    }
    
    this.global.isLoaderEnabled = true;
    this.loading = true;
    this.resetPassword.ConfirmationCode = this.confirmationCode;
    this.resetPassword.UserName = this.userName;
    this.resetPassword.NewPassword = this.global.encryptPassword(this.forgetPasswordForm.controls.newpassword.value);
    this.userService.ResetPassword(this.resetPassword)
      .pipe(first())
      .subscribe(
        (data: ResponseObject) => {
          
          this.responseObject = data;
          if (this.responseObject.Success) {
            //this.alertService.success(this.translate.instant('FRONT_USER.SUCCESS_MESSAGES.CHANGE_PASSWORD'), false);
            this.global.isLoaderEnabled = false;
            this.showRequest=true;
            
            this.router.navigate(['/login']);
            this.loading = false;
          }
          else { 
            
            this.global.isLoaderEnabled = false;
            this.showRequest=false;
            this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + this.responseObject.ErrorMessages[0]), false);

            this.loading = false;
          }

        });
  }



}
